import { render, staticRenderFns } from "./AutomationDepartmentPermissionsTab.vue?vue&type=template&id=5b78d479&scoped=true"
import script from "./AutomationDepartmentPermissionsTab.vue?vue&type=script&lang=js"
export * from "./AutomationDepartmentPermissionsTab.vue?vue&type=script&lang=js"
import style0 from "./AutomationDepartmentPermissionsTab.vue?vue&type=style&index=0&id=5b78d479&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b78d479",
  null
  
)

export default component.exports